import React from 'react'

const About = () => {
    return (
        <div className='about-container' id={'about1'}>
            <div className='container'>
            <div className='about-header'>
                <h1>About Us</h1>
            </div>
            <div className='about-details'>
                <p>At <span>BikeRental</span>, we believe everyone should have access to mobility.
A simple solution to the most complex challenges of the world.</p>
            </div>
            <div className='about-detail'>
                <p>We are a bunch of millennials focused on building India’s largest mobility solutions provider. Our focus has led us to build a platform providing rentals spanning across 14 states, 43 cities and 3 international cities.
Transportation and mobility solutions is one of the least understood and most unorganized markets. We see this as an unexplored opportunity to build a system that can be trusted by everyone beyond barriers.
We have no limitations when it comes to two wheelers and enjoy serving everything from a scooter to a superbike available on both website and mobile application.
We are obsessed with the concept of <span>‘Why buy when you can rent’.</span></p>
            </div>
            </div>
            
        </div>
    )
}

export default About
